import { apiFetch, isWhitespaceString } from '@ami/react/core';
import { QuoteStatus } from '../../quotes/otherQuoteEntities';
import MachineMakeAndModelFilter from '../../machines/machineMakeAndModelFilter';

export class SearchQuoteConfiguration {
  constructor(json) {
    if (json) {
      this.carriers = json.carriers;
      this.makes = json.makes;
      this.models = json.models;
      this.statuses = json.statuses;
      this.dealerGroups = json.dealerGroups;
      this.amiUsers = json.amiUsers;
      return;
    }
    this.carriers = [];
    this.makes = [];
    this.models = [];
    this.statuses = [];
    this.dealerGroups = [];
    this.amiUsers = [];
  }
}

export class SearchQuoteResult {
  constructor(json) {
    this.id = json.id;
    this.name = json.name;
    this.number = json.number;
    this.poNumber = json.poNumber;
    this.date = json.date;
    this.acceptedDate = json.acceptedDate;
    this.completedDate = json.completedDate;
    this.carrier = json.carrier;
    this.machineId = json.machineId;
    this.make = json.make;
    this.model = json.model;
    this.status = json.status;
    this.statusName = QuoteStatus[json.status];
    this.dealerGroup = json.dealerGroup;
    this.dealerBranch = json.dealerBranch;
    this.dealerUser = json.dealerUser;
  }
}

export class SearchQuoteFilter extends MachineMakeAndModelFilter {
  constructor(json) {
    super(json);
    if (json) {
      this.search = json.search;
      this.status = json.status;
      this.startDate = json.startDate;
      this.endDate = json.endDate;
      this.make = json.make;
      this.machineId = json.machineId;
      this.model = json.machineId == null ? null : json.model;
      this.dealerGroupId = json.dealerGroupId;
      this.dealerBranchId = json.dealerBranchId;
      this.dealerUserId = json.dealerUserId;
      this.contactAmiUserId = json.contactAmiUserId;
      this.isForRecentWidget = json.isForRecentWidget;
      this.onlyAssignedToCurrentUser = json.onlyAssignedToCurrentUser;
      this.shippingLocationCountry = json.shippingLocationCountry;
      this.shippingLocationRegion = json.shippingLocationRegion;
      this.productGroupId = json.productGroupId;
      this.onlyActives = json.onlyActives;
      // These are just to pre-populate the async dropdowns.
      this.dealerGroupName = json.dealerGroupName;
      this.dealerBranchName = json.dealerBranchName;
      this.dealerUserName = json.dealerUserName;
      this.partNumber = json.partNumber;
      this.partNumberStatus = json.partNumberStatus;
      this.productGroupName = json.productGroupName;
      this.industryId = json.industryId;
      this.industryName = json.industryName;
      return this;
    }
    this.search = '';
    this.status = null;
    this.startDate = null;
    this.endDate = null;
    this.make = null;
    this.machineId = null;
    this.model = null;
    this.dealerGroupId = null;
    this.dealerBranchId = null;
    this.dealerUserId = null;
    this.contactAmiUserId = null;
    this.isForRecentWidget = false;
    this.onlyAssignedToCurrentUser = false;
    this.shippingLocationCountry = null;
    this.shippingLocationRegion = null;
    this.partNumber = '';
    this.partNumberStatus = null;
    this.productGroupId = null;
    this.productGroupName = '';
    this.onlyActives = false;
    this.industryId = null;
    this.industryName = '';
  }

  toPayload() {
    return {
      ...this,
      search: isWhitespaceString(this.search) ? null : this.search,
      dealerGroupName: undefined,
      dealerBranchName: undefined,
      dealerUserName: undefined,
      productGroupName: undefined,
      startDate: this.mapDate(this.startDate),
      endDate: this.mapDate(this.endDate),
    };
  }
}

export async function searchQuotes(filter, page) {
  const payload = new SearchQuoteFilter(filter.toPayload());
  if (filter.isForRecentWidget) {
    payload.$top = 4;
  } else {
    payload.setPaginationParameters(page);
  }
  const items = await apiFetch(`quotes?${payload.toQueryString()}`);
  return items.map((x) => new SearchQuoteResult(x));
}
